import * as Icons from '@ant-design/icons';

const getIconComponent = (iconName) => {
  const IconComponent = Icons[iconName];
  return IconComponent ? <IconComponent /> : null;
};

export default getIconComponent;
